import {
  REQUEST_ENUM_START,
  REQUEST_ENUM_SUCCESS,
  REQUEST_ENUM_ERROR,
} from '../actions';
import initialState from './initialState';

function enums(state = initialState.enums, action) {
  switch (action.type) {
    case REQUEST_ENUM_START:
      return Object.assign({}, state, {
        isFetching: true,
        path: action.path,
        errorMsg: '',
      });

    case REQUEST_ENUM_SUCCESS: {
      const enumKeys = action.path.split('.');
      const firstKey = enumKeys[0];
      const subKey = enumKeys[1];
      const enumSubHash = Object.assign({}, state[firstKey]);
      enumSubHash[subKey] = action.data;
      const newHash = {};
      newHash[firstKey] = enumSubHash;

      return Object.assign({}, state, {
        errorMsg: '',
        isFetching: false,
      },
      newHash,
      );
    }

    case REQUEST_ENUM_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        errorMsg: action.err.message || process.env.ERR_GENERIC,
      });

    default:
      return state;
  }
}

export default enums;
